module.exports = __webpack_public_path__ + "img/motoboy-03.bc0e0fc5.svg";